import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";

import { menu } from "./modules/menu";
import { account } from "./modules/account";
import { savedOutfits } from "./modules/savedOutfits";
import { savedProducts } from "./modules/savedProducts";
import { cart } from "./modules/cart";
import { config } from "./modules/config";
import { checkout } from "./modules/checkout";
import { generatedOutfits } from "./modules/generatedOutfits";
import { products } from "./modules/products";
import { auth } from "./modules/auth";
import { appVersion } from "./modules/appVersion";
import { filters } from "./modules/filters";
import { onboarding } from "./modules/onboarding";
import { featuredOutfits } from "./modules/featuredOutfits";
import { featuredCollections } from "./modules/featuredCollections";
import { errors } from "./modules/errors";
import { outfits } from "./modules/outfits";
import { transactions } from "./modules/transactions";
import { share } from "./modules/share";
import { quizzes } from "./modules/quizzes";
import { footer } from "./modules/footer";
import { search } from "./modules/search";

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        menu,
        filters,
        account,
        savedOutfits,
        savedProducts,
        cart,
        config,
        checkout,
        generatedOutfits,
        products,
        onboarding,
        auth,
        appVersion,
        featuredOutfits,
        featuredCollections,
        errors,
        outfits,
        transactions,
        share,
        quizzes,
        footer,
        search,
    },
    plugins: [
        createPersistedState({
            key: "themadapp-authv1.0.12.43",
            paths: ["auth"],
        }),
        createPersistedState({
            key: "themadaappv1.1.24",
            paths: [
                "cart",
                "config",
                "account",
                "menu",
                "filters",
                "quizzes",
                "search.productBrands",
                "search.featuredCollections",
            ],
        }),
    ],
});
